<template>
<section class="border-gray-800 border-t p-3">
  <h4 class="text-white text-sm font-bold uppercase mb-3">Associated Tours</h4>
  <div class="gap-3 grid grid-cols-3">
    <div v-for="tour in tours" :key="tour.identifier" class="tour-item">
      <Link :href="route('tour.edit', tour.identifier)">
        <div class="heading">
            <div>{{ tour.title.localized_text[tour.fallback_language] }}</div>
        </div>
        <div class="badge-black-modal">{{ writeStationsCount(tour.stations.length) }}</div>
        <div v-if="tour.image" class="content">
            <img class="object-cover w-full h-full" :src="tour.image[0].first_file_path">
        </div>
      </Link>
    </div>
  </div>
</section>
</template>

<script>
import { writeStationsCount } from '@/Pages/GlobalHelpers';
import { Link } from '@inertiajs/inertia-vue3';

export default {
  components: {
    Link
  },
  props: ['provider'],
  data(){
    return{
      tours: [],
    }
  },
  watch:{
    provider:function(newState, oldState){
      if(newState == null)
      {
        this.tours = [];
        return;
      }
      if(newState.tours.length > 0)
      {
        this.tours = newState.tours;
      } else {
        this.tours = [];
      }
    }
  },
  methods:{
    writeStationsCount
  }
}
</script>